// Import commands to ensure they register themselves
import { AddBankAccountCommand } from "./AddBankAccountCommand";
import { ConnectAccountSourceCommand } from "./ConnectAccountSourceCommand";
import { ConnectBankAccountCommand } from "./ConnectBankAccountCommand";
import { ConnectMailboxCommand } from "./ConnectMailboxCommand";
import { ConnectStripeAccountCommand } from "./ConnectStripeAccountCommand";
import { InviteMemberCommand } from "./InviteMemberCommand";
import { MergeBankAccountsCommand } from "./MergeBankAccountsCommand";
import { NewRuleCommand } from "./NewRuleCommand";
import { ReadDocumentAgainCommand } from "./ReadDocumentAgainCommand";
import { ReconnectBankAccountCommand } from "./ReconnectBankAccountCommand";
import { SelectEntitiesCommand } from "./SelectEntitiesCommand";
import { SendDocumentCommand } from "./SendDocumentCommand";
import { SelectEntityCommand } from "./SelectEntityCommand";
import { SelectFinancialAccountCommand } from "./SelectFinancialAccountCommand";
import { SyncAccountCommand } from "./SyncAccountCommand";
import { UploadToFinancialAccountCommand } from "./UploadToFinancialAccountCommand";

// Export context types
export type { ThreadContextType } from "./ThreadCommand";
export type { AddBankAccountContextType } from "./AddBankAccountCommand";
export type { ConnectAccountSourceContextType } from "./ConnectAccountSourceCommand";
export type { ConnectBankAccountContextType } from "./ConnectBankAccountCommand";
export type { ConnectMailboxContextType } from "./ConnectMailboxCommand";
export type { ConnectStripeAccountContextType } from "./ConnectStripeAccountCommand";
export type { CreateNodeContextType } from "./CreateNodeCommand";
export type { InviteMemberContextType } from "./InviteMemberCommand";
export type { MergeBankAccountsContextType } from "./MergeBankAccountsCommand";
export type { NewRuleContextType } from "./NewRuleCommand";
export type { ReadDocumentAgainContextType } from "./ReadDocumentAgainCommand";
export type { ReconnectBankAccountContextType } from "./ReconnectBankAccountCommand";
export type { ReviewNodesContextType } from "./ReviewNodesCommand";
export type { ReviewUploadContextType } from "./ReviewUploadCommand";
export type { SearchContextType } from "./SearchCommand";
export type { SelectEntitiesContextType } from "./SelectEntitiesCommand";
export type { SendDocumentContextType } from "./SendDocumentCommand";
export type { SelectEntityContextType } from "./SelectEntityCommand";
export type { SelectFinancialAccountContextType } from "./SelectFinancialAccountCommand";
export type { SyncAccountContextType } from "./SyncAccountCommand";
export type { ToggleColorSchemeContextType } from "./ToggleColorSchemeCommand";
export type { TogglePanelVisibilityContextType } from "./TogglePanelVisibilityCommand";
export type { ToggleSidebarVisibilityContextType } from "./ToggleSidebarVisibilityCommand";
export type { ToggleStyleThemeContextType } from "./ToggleStyleThemeCommand";
export type { UpdateNodeContextType } from "./UpdateNodeCommand";
export type { UploadFilesContextType } from "./UploadFilesCommand";
export type { UploadToFinancialAccountContextType } from "./UploadToFinancialAccountCommand";

// Export command registrations
export function CommandRegistrations() {
  return (
    <>
      <AddBankAccountCommand />
      <ConnectAccountSourceCommand />
      <ConnectBankAccountCommand />
      <ConnectMailboxCommand />
      <ConnectStripeAccountCommand />
      <InviteMemberCommand />
      <MergeBankAccountsCommand />
      <NewRuleCommand />
      <ReadDocumentAgainCommand />
      <ReconnectBankAccountCommand />
      <SelectEntitiesCommand />
      <SelectEntityCommand />
      <SendDocumentCommand />
      <SelectFinancialAccountCommand />
      <SyncAccountCommand />
      <UploadToFinancialAccountCommand />
    </>
  );
}
